/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, shape, string, arrayOf, number, func, bool,
} from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Popover from '@material-ui/core/Popover';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReactMarkdown from 'react-markdown';
import AddIcon from '@material-ui/icons/Add';
import AddonInfoModal from '../../../../../GraphqlAddOnsPage/Partials/AddonInfoModal';
import { trackAddOns } from '../../../../../../../helpers/tracking/common/commonTrackingHelpers';

const useStyle = makeStyles((theme) => ({
    img: {
        width: '100%',
        display: 'flex',
        aspectRatio: '54/59',
        border: '1px solid #E9E9E9',
        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
        borderRadius: '5px',
        '&:hover': {
            boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
        },
    },
    imageContainer: {
        textAlign: 'center',
        height: 'auto',
        position: 'relative',
    },
    ctaButton: {
        fontSize: '14px',
        lineHeight: '20px',
        padding: '7px 5px',
        width: '100%',
        margin: '12px auto 0px',
        borderRadius: '3px',
        textTransform: 'capitalize',
        boxShadow: 'none',
        fontWeight: '700',
        '@media screen and (max-width: 600px)': {
            marginBottom: '0px',
        },
        color: '#000000',
        border: '1px solid #F0F0F5',
        textAlign: 'center',
        backgroundColor: '#F9F9FB',
        cursor: 'pointer',
        display: 'flex',
        alignItem: 'center',
        '& svg': {
            width: '14px',
            height: '14px',
            fontSize: '16px',
        },
        '&:hover, &:focus, &:active': {
            color: '#000000',
            border: '1px solid #F0F0F5',
            backgroundColor: '#F9F9FB',
            boxShadow: 'none',
        },
        '& .MuiTouchRipple-child': {
            background: 'transparent',
        },
    },
    title: {
        color: theme?.palette?.black,
        textAlign: 'left',
        width: '100%',
        lineHeight: '19px',
        minHeight: '38px',
        margin: '8px 0px 0px',
        overflow: 'hidden',
        fontSize: '12px',
        paddingRight: '2px',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: '2',
        fontWeight: '500',
        WebkitBoxOrient: 'vertical',
        '@media screen and (max-width: 600px)': {
            fontSize: '15px',
        },
    },
    icon: {
        position: 'relative',
    },

    iconContent: {
        padding: 10,
    },
    listItem: {
    },
    svgIcon: {
        marginLeft: '8px',
    },
}));

const PDPAddonDetailUI = ({
    addonData, handleOpenModal, selectedGroupId, addOnHoverInfo, selectItems, removeItems,
}) => {
    const classes = useStyle();
    const groupId = addonData?.id;
    const groupName = addonData?.name;
    const addons = addonData?.addons;
    const [open, setOpen] = useState(false);

    const transformPriceRange = (item) => ({
        __typename: item.__typename,
        retail: [
            {
                __typename: 'Price',
                value: item.retail.from,
            },
            {
                __typename: 'Price',
                value: item.retail.to,
            },
        ],
        sale: [
            {
                __typename: 'Price',
                value: item.sale.from,
            },
            {
                __typename: 'Price',
                value: item.sale.to,
            },
        ],
    });

    const retailPrice = transformPriceRange(addonData?.price)?.retail?.find((p) => p.__typename === 'Price')?.value;
    const salePrice = transformPriceRange(addonData?.price)?.sale?.find((p) => p.__typename === 'Price')?.value;
    const defaultPrice = transformPriceRange(addonData?.price)?.retail?.find((p) => p.__typename === 'Price')?.value;

    if (addons && addons.length) {
        trackAddOns(addons);
    }
    const [infoPopOver, setInfoPopOver] = useState('');
    const handleInfoPopOver = () => {
        setInfoPopOver('');
    };

    const handlePopup = () => {
        setOpen(true);
    };
    const trashIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
            <path d="M1 4.04706H13M5.80176 7.34882V10.651M8.19824 7.34882V10.651M2.19824 4.04706H11.7982L10.8502 13.4384C10.8177 13.7616 10.6781 14.0602 10.458 14.2771C10.2379 14.494 9.95286 14.614 9.65744 14.6139H4.33904C4.04362 14.614 3.75858 14.494 3.53849 14.2771C3.3184 14.0602 3.17874 13.7616 3.14624 13.4384L2.19824 4.04706ZM4.20641 2.16297C4.30346 1.93642 4.45704 1.74492 4.64922 1.61079C4.84139 1.47667 5.06426 1.40545 5.29181 1.40546H8.70701C8.93466 1.40533 9.15766 1.47648 9.34995 1.61061C9.54225 1.74475 9.69591 1.93632 9.79301 2.16297L10.5994 4.04718H3.39941L4.20641 2.16297Z" stroke="#000000" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
    const onHoverItem = addOnHoverInfo?.reduce((acc, entry) => {
        if (acc) return acc;

        const infoIconItem = entry.add_on?.find((item) => item?.product_sku_part_numbers === groupId && item?.info_on_hover);

        if (infoIconItem) return infoIconItem;

        return acc;
    }, null);

    const LinkOrReference = (prop) => {
        const { href, children } = prop;
        return <a href={href} target="_blank" rel="noreferrer">{children}</a>;
    };

    const renderPrice = () => (
        <span className={classes.setItemLayout}>
            {salePrice && retailPrice && salePrice !== retailPrice
                ? (
                    <>
                        <s>
                            ${retailPrice}
                        </s>
                        <span className={classes.salePrice}>
                            ${salePrice}
                        </span>
                    </>
                )
                : <span className={classes.defaultPrice}> ${defaultPrice}</span>}
        </span>
    );
    const renderButton = (addOns) => (
        addonData?.addons?.length > 1
            ? (
                <Button
                    id={`btn-${groupId}`}
                    variant="contained"
                    disableRipple
                    disableFocusRipple
                    className={classes.ctaButton}
                    onClick={() => handleOpenModal('addons', addons, groupId, groupName, 'Select')}
                >
                    See Options
                </Button>
            )
            :                           (
                <Button
                    id={`btn-${groupId}`}
                    variant="contained"
                    disableRipple
                    disableFocusRipple
                    className={classes.ctaButton}
                    onClick={() => selectItems(addOns?.[0], groupId, groupName)}
                >
                    Add <AddIcon /> {renderPrice()}
                </Button>
            )
    );
    const addToCartButton = () => (
        selectedGroupId
            ? (
                <Button
                    id={`btn-${groupId}`}
                    variant="contained"
                    disableRipple
                    disableFocusRipple
                    className={`${classes.ctaButton}`}
                    onClick={() => removeItems(addons?.[0], groupId, groupName)}
                >
                    Added <span className={classes.svgIcon}>{trashIcon()}</span>
                </Button>
            )
            : (
                renderButton(addons)
            )
    );

    return (
        <div className={`${classes.addOnListContainer}`}>
            <div
                className={`${classes.listItem}`}
            >
                <div className={classes.imgContent} role="presentation"  onClick={() => handlePopup()}>
                    <img
                        className={classes.img}
                        src={`${addons[0].image.path}${addons[0].image.name}c.jpg?quality=100`}
                        alt={addons[0].image.name}
                    />
                </div>
                <div className={classes.icon}>
                    <Popover
                        open={infoPopOver}
                        anchorEl={infoPopOver}
                        onClose={handleInfoPopOver}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <div className={classes.iconContent}>
                            <ReactMarkdown
                                escapeHtml={false}
                                source={onHoverItem?.info_on_hover}
                                renderers={{
                                    linkReference: LinkOrReference,
                                }}
                            />
                        </div>
                    </Popover>
                    <div role="presentation" onClick={() => handlePopup()} className={classes.title}>{groupName}</div>
                </div>
                {addToCartButton() }
                {open && (
                    <AddonInfoModal
                        open={open}
                        setOpen={setOpen}
                        heading={addonData.name}
                        imageData={addonData?.addons?.[0]}
                        description={onHoverItem?.info_on_hover}
                        LinkOrReference={LinkOrReference}
                    />
                )}
            </div>
        </div>
    );
};

PDPAddonDetailUI.propTypes = {
    addonData: shape({
        id: string,
        name: string,
        addons: arrayOf(shape({
            id: string,
            image: object,
            name: string,
            partNumber: string,
            prices: arrayOf(shape({
                type: string,
                value: number,
            })),
        })).isRequired,
    }).isRequired,
    handleOpenModal: func.isRequired,
    selectedGroupId: string.isRequired,
    addOnHoverInfo: arrayOf(shape({
        info_on_hover: string,
        product_sku_part_numbers: string,
        see_more_info: string,
    })).isRequired,
    selectItems: func.isRequired,
    removeItems: func.isRequired,
};

export default PDPAddonDetailUI;
